import React, {useEffect, useState} from 'react'
import {Button, Divider, Typography} from "antd";
import Tour from "reactour";
import {checkFirstTimePiecesUser} from "../../app/util";

const {Title} = Typography


export default (props) => {
    const [open, setOpen] = useState(false)
    const [stepNum, setStepNum] = useState(0)
    const [curNum, setCurNum] = useState(0)

    useEffect(()=>{
        if (window !== undefined) {
            let open = checkFirstTimePiecesUser(props)
            setOpen(open)
        }
    }, [])

    const StepView1 = () => {
        return (
            <>
                <iframe width="560" style={{maxWidth: '100%'}} height="315"
                        src="https://www.youtube.com/embed/FheSpVSccwY"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                ></iframe>
                <center>
                    <Title level={1} style={{fontSize: 12, marginTop: 12}}>Welcome to RevArt! 👋</Title>
                    <p style={{lineHeight: '2rem'}}>Hey, we're thrilled to have you here! <br/>
                        Welcome to RevArt SMART Manager! You can view the little video up above to get started on your trip and take full use of the tools and opportunities we have waiting for you! </p>
                </center>
                <BottomActionFirstView/>
            </>
        )
    }

    const BottomActionFirstView = () => {
        return (
            <>
                <Divider/>
                <div style={{display: 'flex'}}>
                    <Button type={'text'} style={{marginLeft: 12, marginRight: 'auto'}}
                            onClick={() => setOpen(false)}>Skip</Button>
                    <span style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: 8
                    }}>{`${curNum} of ${steps.length}`}</span>
                    <Button type={'primary'} style={{marginLeft: 'auto', marginRight: 12, fontWeight: "bold"}}
                            onClick={() => {
                                setStepNum(1)
                            }}>Take the tour</Button>
                </div>
            </>
        )
    }

    const BottomActionLastView = () => {
        return (
            <>
                <Divider/>
                <div style={{display: 'flex'}}>
                    <Button type={'text'} style={{marginLeft: 12, marginRight: 'auto'}}
                            onClick={() => setStepNum(1)}>Restart</Button>
                    <Button type={'primary'} style={{marginLeft: 'auto', marginRight: 12, fontWeight: "bold"}}
                            onClick={() => {
                                setOpen(false)
                                setStepNum(0)
                            }}>Done</Button>
                </div>
            </>
        )
    }

    const BasicLayout = ({children}) => {
        return <div>
            {children}
        </div>
    }

    const BottomActionView = () => {
        return (
            <>
                <Divider/>
                <div style={{display: 'flex', verticalAlign: 'middle'}}>
                    <Button type={'text'} style={{marginLeft: 12, marginRight: 'auto'}}
                            onClick={() => setStepNum(Math.max(stepNum - 1, 0))}>Prev</Button>
                    <span style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: 8
                    }}>{`${curNum} of ${steps.length}`}</span>
                    <Button type={'primary'} style={{marginLeft: 'auto', marginRight: 12, fontWeight: "bold"}}
                            onClick={() => {
                                setStepNum(stepNum + 1)
                            }}>Next</Button>
                </div>
            </>
        )
    }

    const TitleText = ({title}) => {
        return <center><Typography style={{fontSize: 24, fontWeight: "bold"}}>{title}</Typography></center>
    }

    const ParaText = ({children}) => {
        return (
            <p style={{marginTop: 12}}>{children}</p>
        )
    }

    const steps = [
        {
            selector: '[data-tut="reactour__create"]',
            content: <BasicLayout>
                    <TitleText title={'Upload Piece'}></TitleText>
                    <ParaText>To add a new piece to the system, click "Upload Piece."
                                <br/>
                                You will be prompted to upload a photo of your artwork as well as some more details about the item.
                        </ParaText>
                    <BottomActionView/>
            </BasicLayout>,
        },
        {
            selector: '[data-tut="reactour__import"]',
            content: <BasicLayout>
                <TitleText title={'Import'}></TitleText>
                <ParaText>
                    <h4>1.Bulk Image Upload</h4>
                    You can upload a folder of work: a maximum of 20 photos or a number of images to import the pieces you wish to add.  <br/>
                    <h4 style={{marginTop: 12}}>2.Artwork Sheet Upload</h4>
                    You can update the details of numerous artworks at once using this feature. Download the attached Excel sheet template, complete the fields on it, and then upload it again here.
                </ParaText>
                <BottomActionView/>
            </BasicLayout>,
        },
        {
            selector: '[data-tut="reactour__export"]',
            content: <BasicLayout>
                <TitleText title={'Export'}></TitleText>
                <ParaText>
                    <h4>1.Export to Excel</h4>
                  Click "Export" and then "Export to Excel," then choose the fields whose data you wish to export. You will receive an Excel document containing inventory information when you use this feature.
                   <br/>
                    <h4 style={{marginTop: 12}}>2.Export to Inventory Report</h4>
                 Click "Export" and then "export to Inventory Report" to export your inventory report in PDF format and print it. This will take you to a separate window where your art inventory is shown in the format of a gallery inventory report. You have the option to download or print it.
                </ParaText>
                <BottomActionView/>
            </BasicLayout>,
        },
        {
            selector: '',
            content: <BasicLayout>
                <TitleText title={'🎊 You\'re all set! 🎊\n'}></TitleText>
                <ParaText>
                       <ul style={{lineHeight: '175%'}}>
                        <li><span>Organize and Manage Collections</span>
                        </li>
                        <li><span>Export Art Catalog in One Click</span>
                        </li>
                        <li><span>Manage Exhibitions and Track Your Inventory</span>
                        </li>
                    </ul>
                </ParaText>
                <BottomActionLastView/>
            </BasicLayout>,
        },
    ]

    return (
        <>
            <Tour
                rounded={5}
                isOpen={open}
                goToStep={stepNum}
                className={'my-tour'}
                accentColor={'#0531ad'}
                badgeContent={(curr, tot) => {if (curr !== curNum) setCurNum(curr); return `${curr} of ${tot}`}}
                disableDotsNavigation={true}
                onAfterOpen={(target) => (document.body.style.overflowY = 'hidden')}
                onBeforeClose={(target) => (document.body.style.overflowY = 'auto')}
                onRequestClose={() => {
                    setOpen(false);
                    setStepNum(0)
                }}
                prevButton={() => {
                    return null
                }}
                nextButton={() => {
                    return null
                }}
                showNavigation={true}
                steps={steps}/>
        </>
    )
}